import React from 'react';
import { styled } from '@mui/system';
import { Select } from '@mui/material';

export const InlineLabelSelect = styled((props) => (
	<Select
		{...props}
		// MenuProps={{
		// 	anchorEl: props.anchorItem
		// }}
	/>
))({
	paddingLeft: '4px',

	'& .MuiOutlinedInput-input': {
		paddingTop: '4px',
		paddingBottom: '4px',
		fontSize: '14px',
		textTransform: 'capitalize',
	},
	'& .MuiListItemIcon-root': {
		display: 'none',
	},
	'& .MuiTypography-root': {
		fontSize: '14px',
	},
});
